import React from 'react'

const TimeUnit = ({ tag, available, label, childStyle, isHalf, ...props }) => {
  return (
    <div
      className={
        'timeUnit' +
        (tag ? ` ${tag}` : '') +
        (!available ? ' blocked' : '') +
        (isHalf ? ' half' : '')
      }
      {...props}
    >
      <div style={childStyle}>{label}</div>
    </div>
  )
}

export default TimeUnit
